import React from "react";
import { Link } from "react-router-dom";
import { Form, Button, Container, Row, Col, Tab, Nav } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import GeneralTabEvaluationSchemeForm from "presentation/pages/evaluation-schemes/elements/form-tabs/general";
import PeriodsTabEvaluationSchemeForm from "presentation/pages/evaluation-schemes/elements/form-tabs/periods";
import PeriodFormulasTabEvaluationSchemeForm from "presentation/pages/evaluation-schemes/elements/form-tabs/period-formulas";
import StageFormulasTabEvaluationSchemeForm from "presentation/pages/evaluation-schemes/elements/form-tabs/stage-formulas";
import StageCriteriasTabEvaluationSchemeForm from "presentation/pages/evaluation-schemes/elements/form-tabs/stage-criterias";
import StatusIndicationTabEvaluationSchemeForm from "presentation/pages/evaluation-schemes/elements/form-tabs/status-indication";
import FinalResultTabEvaluationSchemeForm from "presentation/pages/evaluation-schemes/elements/form-tabs/final-result";

import evaluationTypesService from "presentation/services/evaluation-types";


class EvaluationSchemeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            localLoading: true,
            localError: false,
            message: '',
            evaluationTypes: [],

        }

    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => {

        let evaluationTypes = [];

        await evaluationTypesService.findAll().then((result) => {
            evaluationTypes = result;
        });

        this.setState({ localLoading: false, evaluationTypes: evaluationTypes });
    }

    render() {
        let {
            loading,
            message,
            evaluationSchemeForm,
            handleSubmit,
            component,
            stages,
            totalStageItems,
            periods,
            totalPeriodItems,
            stageCriterias,
            totalStageCriteriaItems,
            statusIndications,
            totalStatusIndicationItems
        } = this.props;

        let {
            localLoading,
            localError,
            evaluationTypes
        } = this.state;

        let childrenParams = {
            component: component,
            evaluationSchemeForm: evaluationSchemeForm,
            stages: stages,
            totalStageItems: totalStageItems,
            loading: loading,
            periods: periods,
            totalPeriodItems: totalPeriodItems,
            evaluationTypes: evaluationTypes,
            stageCriterias: stageCriterias,
            totalStageCriteriaItems: totalStageCriteriaItems,
            statusIndications: statusIndications,
            totalStatusIndicationItems: totalStatusIndicationItems
        };
        return (
            <Form className="mb-5">
                {loading === true || localLoading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                {(localLoading === false && localError === true) && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {
                    loading === false && localLoading === false && (

                        <Container>
                            <Row>
                                <Col>
                                    <Tab.Container id="left-tabs" defaultActiveKey="general">
                                        <Row>
                                            <Col sm={2}>
                                                <Nav variant="pills" className="flex-column">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="general">Dados gerais</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="periods">Períodos</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="period-formulas">Fórmulas períodos</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="stage-formulas">Fórmulas etapas</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="stage-criterias">Critérios de aprovação</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="status-indication">Indicação de situação</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="final-result">Resultado final</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </Col>
                                            <Col sm={10}>
                                                <Container>
                                                    <Row>
                                                        <Col>
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="general">
                                                                    <GeneralTabEvaluationSchemeForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="periods">
                                                                    <PeriodsTabEvaluationSchemeForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="period-formulas">
                                                                    <PeriodFormulasTabEvaluationSchemeForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="stage-formulas">
                                                                    <StageFormulasTabEvaluationSchemeForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="stage-criterias">
                                                                    <StageCriteriasTabEvaluationSchemeForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="status-indication">
                                                                    <StatusIndicationTabEvaluationSchemeForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="final-result">
                                                                    <FinalResultTabEvaluationSchemeForm {...childrenParams} />
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <div className="mt-3 mb-5">
                                                                <CancelButton
                                                                    containerProps={{
                                                                        as: Link,
                                                                        to: '/regimes-avaliacao'
                                                                    }}
                                                                />
                                                                <Button disabled={loading} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </Col>
                            </Row>
                        </Container>
                    )}
            </Form>
        );
    };
}

export default EvaluationSchemeForm;